var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTag1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.707 3.293C13.6143 3.19996 13.5041 3.12617 13.3828 3.07589C13.2614 3.0256 13.1313 2.99981 13 3H4C3.73478 3 3.48043 3.10536 3.29289 3.29289C3.10536 3.48043 3 3.73478 3 4V13C3 13.266 3.105 13.52 3.293 13.707L11.293 21.707C11.3857 21.8002 11.4958 21.8741 11.6171 21.9246C11.7385 21.9751 11.8686 22.001 12 22.001C12.1314 22.001 12.2615 21.9751 12.3829 21.9246C12.5042 21.8741 12.6143 21.8002 12.707 21.707L21.707 12.707C21.7999 12.6142 21.8737 12.504 21.924 12.3827C21.9743 12.2614 22.0002 12.1313 22.0002 12C22.0002 11.8687 21.9743 11.7386 21.924 11.6173C21.8737 11.496 21.7999 11.3858 21.707 11.293L13.707 3.293V3.293ZM12 19.586L5 12.586V5H12.586L19.586 12L12 19.586Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49597 10C9.32716 10 10.001 9.32619 10.001 8.49501C10.001 7.66382 9.32716 6.99001 8.49597 6.99001C7.66478 6.99001 6.99097 7.66382 6.99097 8.49501C6.99097 9.32619 7.66478 10 8.49597 10Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag1);
export default __webpack_public_path__ + "static/media/tag1.25cf9a515ff38e933bd11556401def83.svg";
export { ForwardRef as ReactComponent };